/** Cada cuánto se pregunta si llegó una solicitud: poco, para que se sienta en vivo. */
export const VUELTA_MS = 15_000;

/** «Recordármelo después»: lo que se calla el aviso, si no llega nada nuevo. */
export const POSPONER_MS = 10 * 60_000;

/**
 * Qué hace el aviso de dispositivos con lo que acaba de saber (ADR-0026):
 *
 * - `nuevo`: llegó una solicitud que no había visto. Sale siempre, aunque lo
 *   haya pospuesto: es justo lo que no se puede perder.
 * - `recordatorio`: siguen esperando y ya pasó lo pospuesto. Es lo que hace que
 *   no se olvide.
 * - `ocultar`: no hay nada pendiente, o ya está en la bandeja, donde el aviso
 *   sobra.
 * - `igual`: lo que se ve —o no se ve— se queda como está.
 *
 * La primera vez que se pregunta no hay «nuevo»: lo que ya esperaba al entrar es
 * un recordatorio, no una sorpresa.
 */
export type Decision = 'nuevo' | 'recordatorio' | 'ocultar' | 'igual';

export function decidirAviso(e: {
  pendientes: number;
  ultimaId?: string | undefined;
  vistaId: string | null;
  primeraVez: boolean;
  mostrando: boolean;
  enLaBandeja: boolean;
  ahora: number;
  posponerHasta: number;
}): Decision {
  if (e.pendientes === 0 || e.enLaBandeja) return 'ocultar';
  if (!e.primeraVez && e.ultimaId && e.ultimaId !== e.vistaId) return 'nuevo';
  if (e.mostrando) return 'igual';
  return e.ahora >= e.posponerHasta ? 'recordatorio' : 'igual';
}
